var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"viedo",staticStyle:{"padding-top":"200px"}},[_c('video',{ref:"videoPlayer",attrs:{"id":"videoPlayer","width":"414","preload":"auto","playsinline":"","webkit-playsinline":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }